import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { ApiResponse } from "../../../types/APIResponse";
import { EmailLog, LostItemLogsData, PaymentLog } from "../../../types/ActivityLog";

// get all Activity logs
export const getAllActivityLogs = createAsyncThunk<{ data: LostItemLogsData[]; counts: number; limit: number }, { offset: number; limit: number; searchField?: any; searchValue: any; fromDate?: string; toDate?: string; dateField?: string; keepPaymentLog?: boolean; establishmentType: string | null }, { rejectValue: string }>(
    "logs/getAllActivityLogs",
    async ({ offset, limit, searchField, searchValue, fromDate, toDate, dateField, keepPaymentLog, establishmentType }, { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<LostItemLogsData[]> & { counts: number; limit: number }>(apiEndpoints.activityLog.getAllActivityLogs, {
                data: {
                    offset,
                    limit,
                    searchField,
                    searchValue,
                    order: { "activityLog.createdAt": "DESC" },
                    fromDate,
                    toDate,
                    dateField,
                    establishmentType,
                    kpl: keepPaymentLog
                },
            });
            return {
                data: response.data, // Access nested data from the response
                counts: response.counts,
                limit: response.limit,
            };
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to fetch admin users");
        }
    }
);

// get all Email logs
export const getAllEmailLogs = createAsyncThunk<{ data: EmailLog[]; counts: number; limit: number }, { offset: number; limit: number; searchField?: any; searchValue: any; fromDate?: string; toDate?: string; dateField?: string; keepPaymentLog?: boolean; establishmentType: string | null }, { rejectValue: string }>(
    "logs/getAllEmailLogs",
    async ({ offset, limit, searchField, searchValue, fromDate, toDate, dateField, keepPaymentLog, establishmentType }, { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<EmailLog[]> & { counts: number; limit: number }>(apiEndpoints.activityLog.getAllEmailLogs, {
                data: {
                    offset,
                    limit,
                    searchField,
                    searchValue,
                    order: { "emailLog.createdAt": "DESC" },
                    fromDate,
                    toDate,
                    dateField,
                    establishmentType,
                    kpl: keepPaymentLog
                },
            });
            return {
                data: response.data,
                counts: response.counts,
                limit: response.limit,
            };
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to fetch admin users");
        }
    }
);


// get all Payment logs
export const getAllPaymentLogs = createAsyncThunk<
    { data: PaymentLog[]; counts: number; limit: number; succeededCount: number; failedCount: number; refundedCount: number; totalCount: number },
    { offset: number; limit: number; searchField?: any; searchValue: any; fromDate?: string; toDate?: string; dateField?: string; establishmentType: string | null; paypalOrderStatus?: string; paymentStatus?: number },
    { rejectValue: string }
>(
    "logs/getAllPaymentLogs",
    async ({ offset, limit, searchField, searchValue, fromDate, toDate, dateField, establishmentType, paypalOrderStatus, paymentStatus }, { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<PaymentLog[]> & { counts: number; limit: number; succeededCount: number; failedCount: number; refundedCount: number; totalCount: number }>(apiEndpoints.activityLog.getAllPaymentLogs, {
                data: {
                    offset,
                    limit,
                    searchField,
                    searchValue,
                    order: { "payment.createdAt": "DESC" },
                    fromDate,
                    toDate,
                    establishmentType,
                    dateField,
                    paypalOrderStatus,
                    paymentStatus
                },
            });
            return {
                data: response.data,
                counts: response.counts,
                limit: response.limit,
                succeededCount: response.succeededCount || 0,
                failedCount: response.failedCount || 0,
                refundedCount: response.refundedCount || 0,
                totalCount: response.totalCount || 0,
            };
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to fetch payment logs");
        }
    }
);
